<template>
  <d2-container>
    <!-- 筛选工具栏 -->
    <div class="toolbar">
      <el-select
        v-model="filter.structureTag"
        placeholder="结构标签"
        clearable
        size="mini"
        style="width: 140px; margin-right: 8px;"
        @change="loadChips"
      >
        <el-option
          v-for="item in structureTagOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="filter.productType"
        placeholder="产品类型"
        clearable
        size="mini"
        style="width: 140px; margin-right: 8px;"
        @change="loadChips"
      >
        <el-option
          v-for="item in productTypeOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="filter.status"
        placeholder="状态"
        clearable
        size="mini"
        style="width: 100px; margin-right: 8px;"
        @change="loadChips"
      >
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        size="mini"
        icon="el-icon-circle-plus"
        @click="openDialog()"
      >新增Chip</el-button>
      <el-button
        size="mini"
        icon="el-icon-video-play"
        @click="openTestDialog"
      >测试替换</el-button>
    </div>

    <!-- 列表 -->
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      :loading="listLoading"
      :data="chipList"
    >
      <el-table-column align="center" label="ID" prop="id" width="80" />
      <el-table-column align="center" label="名称" prop="name" min-width="140" />
      <el-table-column align="center" label="结构标签" width="120">
        <template slot-scope="scope">
          <el-tag :type="getTagType(scope.row.structureTag)" size="small">
            {{ structureTagMap[scope.row.structureTag] || scope.row.structureTag }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="适用产品" min-width="160">
        <template slot-scope="scope">
          <el-tag
            v-for="pt in parseProductTypes(scope.row.productTypes)"
            :key="pt"
            size="mini"
            style="margin-right: 4px;"
          >{{ productTypeMap[pt] || pt }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="描述" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.description || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="内容预览" min-width="200">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="400">
            <div class="content-preview" v-html="formatPreviewContent(scope.row.content, scope.row.variables)"></div>
            <div slot="reference" class="content-short" v-html="formatPreviewContent(renderShortContent(scope.row.content), scope.row.variables)"></div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="变量数" width="80">
        <template slot-scope="scope">
          {{ getVariableCount(scope.row.variables) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort" width="70" />
      <el-table-column align="center" label="状态" width="80">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="openDialog(scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleRemove(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入Chip名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input-number v-model="form.sort" :min="0" :step="1" step-strictly style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="结构标签" prop="structureTag">
              <el-select v-model="form.structureTag" placeholder="请选择结构标签" style="width: 100%;">
                <el-option
                  v-for="item in structureTagOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用产品" prop="productTypes">
              <el-select
                v-model="form.productTypes"
                multiple
                placeholder="请选择适用产品"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in productTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" prop="description">
          <el-input v-model="form.description" placeholder="用于前端展示，用户看不到完整内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="内容模板" prop="content">
          <variable-input
            v-model="form.content"
            :variables="form.variables"
            :placeholder="'Chip内容模板，变量格式: {{变量名}}'"
            ref="timeInput"
          />
          <div class="variable-tags" v-if="form.variables && form.variables.length > 0">
            <div class="variable-tags-label">点击插入变量:</div>
            <el-tag
              v-for="(item, index) in form.variables"
              :key="index"
              size="small"
              class="variable-tag-item"
              @click="insertVariable(item)"
            >
              {{ item.label || item.name }}
            </el-tag>
          </div>
        </el-form-item>

        <!-- 变量定义 -->
        <el-form-item label="变量定义">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="addVariable">添加变量</el-button>
        </el-form-item>
        <div v-for="(variable, index) in form.variables" :key="index" class="variable-item">
          <el-card shadow="hover" class="variable-card">
            <div slot="header" class="variable-header">
              <span>变量 {{ index + 1 }}</span>
              <el-button type="text" icon="el-icon-delete" @click="removeVariable(index)">删除</el-button>
            </div>
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="变量名" label-width="70px" :prop="'variables.' + index + '.name'" :rules="variableRules.name">
                  <el-input v-model="variable.name" placeholder="如: metal_type" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="显示名" label-width="70px" :prop="'variables.' + index + '.label'" :rules="variableRules.label">
                  <el-input v-model="variable.label" placeholder="如: 金属类型" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="类型" label-width="70px" :prop="'variables.' + index + '.type'" :rules="variableRules.type">
                  <el-select v-model="variable.type" placeholder="选择类型" size="small" style="width: 100%;">
                    <el-option label="文本" value="text" />
                    <el-option label="数字" value="number" />
                    <el-option label="单选" value="select" />
                    <el-option label="多选" value="multiselect" />
                    <el-option label="颜色" value="color" />
                    <el-option label="图片" value="image" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="默认值" label-width="70px">
                  <el-input v-model="variable.defaultValue" placeholder="默认值" size="small"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="必填" label-width="70px">
                  <el-switch v-model="variable.required" size="small"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="描述" label-width="70px">
                  <el-input v-model="variable.description" placeholder="变量描述" size="small"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item v-if="variable.type === 'select' || variable.type === 'multiselect'" label="选项" label-width="70px">
              <el-select
                v-model="variable.options"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="输入选项后回车添加"
                size="small"
                style="width: 100%;"
              />
            </el-form-item>
          </el-card>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 测试替换对话框 -->
    <el-dialog
      title="测试Chip替换"
      :visible.sync="testDialogVisible"
      width="700px"
    >
      <el-form label-width="80px">
        <el-form-item label="输入文本">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="testInput"
            placeholder='输入包含chip引用的文本，如: 请设计 [chip:1:金属材质:{"metal_type":"铂金"}] 的戒指'
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleTestResolve">执行替换</el-button>
        </el-form-item>
        <el-form-item label="输出结果" v-if="testOutput">
          <div class="test-output">{{ testOutput }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getPromptChipList,
  getPromptChipDetail,
  addPromptChip,
  updatePromptChip,
  removePromptChip,
  updatePromptChipStatus,

  testResolveChip
} from '@/api/common/prompt'
import VariableInput from '@/components/VariableInput'

export default {
  name: 'promptChip',
  components: { VariableInput },
  data () {
    return {
      tableKey: 0,
      listLoading: false,
      chipList: [],
      filter: {
        structureTag: null,
        productType: null,
        status: null
      },
      // 结构标签选项
      structureTagOptions: [
        { label: '操作指令', value: 'operation' },
        { label: '产品描述', value: 'product' },
        { label: '目标对象', value: 'target' },
        { label: '约束条件', value: 'constraint' },
        { label: '质量要求', value: 'quality' }
      ],
      structureTagMap: {
        operation: '操作指令',
        product: '产品描述',
        target: '目标对象',
        constraint: '约束条件',
        quality: '质量要求'
      },
      // 产品类型选项
      productTypeOptions: [
        { label: '戒指', value: 'ring' },
        { label: '项链', value: 'necklace' },
        { label: '手链', value: 'bracelet' },
        { label: '耳环', value: 'earring' }
      ],
      productTypeMap: {
        ring: '戒指',
        necklace: '项链',
        bracelet: '手链',
        earring: '耳环'
      },
      // 对话框
      dialogVisible: false,
      dialogTitle: '新增Chip',
      form: {
        id: null,
        name: '',
        content: '',
        description: '',
        productTypes: [],
        structureTag: '',
        variables: [],
        sort: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        content: [{ required: true, message: '请输入内容模板', trigger: 'blur' }],
        structureTag: [{ required: true, message: '请选择结构标签', trigger: 'change' }],
        productTypes: [{ required: true, message: '请选择适用产品', trigger: 'change', type: 'array' }]
      },
      variableRules: {
        name: [{ required: true, message: '请输入变量名', trigger: 'blur' }],
        label: [{ required: true, message: '请输入显示名', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }]
      },
      // 测试对话框
      testDialogVisible: false,
      testInput: '',
      testOutput: ''
    }
  },
  created () {
    this.loadChips()
  },
  methods: {
    loadChips () {
      this.listLoading = true
      const params = {}
      if (this.filter.structureTag) params.structureTag = this.filter.structureTag
      if (this.filter.productType) params.productType = this.filter.productType
      if (this.filter.status !== null && this.filter.status !== undefined) params.status = this.filter.status

      getPromptChipList(params)
        .then(res => {
          this.chipList = res || []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    parseProductTypes (val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      try {
        return JSON.parse(val)
      } catch (e) {
        return []
      }
    },
    parseVariables (val) {
      if (!val) return []
      if (Array.isArray(val)) return val
      try {
        return JSON.parse(val)
      } catch (e) {
        return []
      }
    },
    getVariableCount (val) {
      const vars = this.parseVariables(val)
      return vars.length
    },
    getTagType (tag) {
      const typeMap = {
        operation: 'danger',
        product: 'success',
        target: 'warning',
        constraint: 'info',
        quality: ''
      }
      return typeMap[tag] || ''
    },
    renderShortContent (content) {
      if (!content) return '--'
      return content.length > 50 ? `${content.slice(0, 50)}...` : content
    },
    openDialog (row) {
      this.dialogTitle = row ? '编辑Chip' : '新增Chip'
      this.dialogVisible = true
      if (row) {
        // 编辑模式，获取详情
        getPromptChipDetail(row.id).then(res => {
          this.form = {
            id: res.id,
            name: res.name,
            content: res.content,
            description: res.description || '',
            productTypes: this.parseProductTypes(res.productTypes),
            structureTag: res.structureTag,
            variables: this.parseVariables(res.variables).map(v => ({
              ...v,
              options: v.options || []
            })),
            sort: res.sort || 0
          }
        })
      } else {
        this.form = {
          id: null,
          name: '',
          content: '',
          description: '',
          productTypes: [],
          structureTag: '',
          variables: [],
          sort: 0
        }
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    addVariable () {
      this.form.variables.push({
        name: '',
        type: 'text',
        label: '',
        description: '',
        defaultValue: '',
        required: false,
        options: []
      })
    },
    removeVariable (index) {
      this.form.variables.splice(index, 1)
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const payload = {
          name: this.form.name,
          content: this.form.content,
          description: this.form.description,
          productTypes: this.form.productTypes,
          structureTag: this.form.structureTag,
          variables: this.form.variables.length > 0 ? this.form.variables : null,
          sort: this.form.sort
        }
        const request = this.form.id
          ? updatePromptChip(this.form.id, payload)
          : addPromptChip(payload)
        request.then(() => {
          this.$message({
            message: this.form.id ? '更新成功' : '新增成功',
            type: 'success',
            center: true
          })
          this.dialogVisible = false
          this.loadChips()
        })
      })
    },
    handleStatusChange (row) {
      updatePromptChipStatus(row.id, row.status).then(() => {
        this.$message({
          message: row.status === 1 ? '已启用' : '已禁用',
          type: 'success',
          center: true
        })
      }).catch(() => {
        // 恢复原状态
        row.status = row.status === 1 ? 0 : 1
      })
    },
    handleRemove (row) {
      this.$confirm('此操作将删除该Chip, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => removePromptChip(row.id))
        .then(() => {
          this.$message({
            message: '删除成功',
            type: 'success',
            center: true
          })
          this.loadChips()
        })
        .catch(() => {})
    },
    openTestDialog () {
      this.testDialogVisible = true
      this.testOutput = ''
    },
    handleTestResolve () {
      if (!this.testInput) {
        this.$message.warning('请输入测试文本')
        return
      }
      testResolveChip(this.testInput).then(res => {
        this.testOutput = res
      })
    },
    resetForm () {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.form = {
        id: null,
        name: '',
        content: '',
        description: '',
        productTypes: [],
        structureTag: '',
        variables: [],
        sort: 0
      }
    },
    insertVariable (variable) {
      if (!variable || !variable.name || !this.$refs.timeInput) return
      this.$refs.timeInput.insertVariable(variable)
    },
    formatPreviewContent (content, variablesVal) {
      if (!content) return '--'
      const variables = this.parseVariables(variablesVal)
      const varMap = {}
      variables.forEach(v => {
        varMap[v.name] = v
      })

      return content.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
        const v = varMap[key]
        const label = v ? (v.label || key) : key
        const value = v ? (v.defaultValue || key) : key

        return `<span class="preview-tag">` +
               `<span class="preview-tag-label">${label}: </span>` +
               `<span class="preview-tag-value">${value}</span>` +
               `</span>`
      }).replace(/\n/g, '<br>')
    }
  }
}
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.content-preview {
  white-space: pre-wrap;
  word-break: break-word;
}
.variable-item {
  margin-bottom: 12px;
}
.variable-card {
  background: #f9f9f9;
}
.variable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.test-output {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}
.variable-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.variable-tags-label {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
.variable-tag-item {
  margin-right: 8px;
  margin-bottom: 4px;
  cursor: pointer;
  user-select: none;
}
.variable-tag-item:hover {
  opacity: 0.8;
}
.content-short {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Grid preview styles - global or deep selector needed if scoped */
::v-deep .preview-tag {
  display: inline-block;
  padding: 0 4px;
  margin: 0 2px;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  color: #67c23a;
  font-size: 12px;
  line-height: 18px;
  vertical-align: middle;
}
::v-deep .preview-tag-label {
  font-size: 0.85em;
  color: #909399;
  margin-right: 2px;
}
::v-deep .preview-tag-value {
  font-weight: 500;
}
</style>
